import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import App from '@/App';
import { initTheme } from '@/components/ThemeToggle';
import { maybeInitSentryFromConsent, SentryErrorBoundary } from '@/lib/observability';
import { installDevSeed } from '@/v2/devSeed';

// Samočistenie: appka už nepoužíva service worker. Zabi akúkoľvek "zombie"
// kópiu z minulých PWA buildov (zaseknutý SW + Cache Storage), ktorá by
// inak servírovala starý kód aj po deployi. Bezpečné — nič tu necachujeme.
(function purgeStaleAppCopies() {
  try {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations()
        .then((regs) => regs.forEach((r) => r.unregister()))
        .catch(() => {});
    }
    if (typeof caches !== 'undefined' && caches.keys) {
      caches.keys()
        .then((keys) => keys.forEach((k) => caches.delete(k)))
        .catch(() => {});
    }
  } catch (_) { /* best-effort */ }
})();

initTheme();
maybeInitSentryFromConsent();
installDevSeed(); // dev-only: window.__v2seed (no-op v produkčnom builde)

function ErrorFallback({ resetError }) {
  return (
    <div
      role="alert"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        fontFamily: 'inherit',
      }}
    >
      <div style={{ maxWidth: 420, textAlign: 'center' }}>
        <h1 style={{ fontSize: 22, marginBottom: 8 }}>Niečo sa pokazilo</h1>
        <p style={{ color: 'var(--text-secondary)', marginBottom: 16, fontSize: 14 }}>
          Skús obnoviť stránku. Ak problém pretrváva, daj nám vedieť.
        </p>
        <button
          type="button"
          onClick={resetError}
          style={{
            padding: '10px 18px',
            borderRadius: 8,
            border: 'none',
            background: 'var(--product-primary)',
            color: '#fff',
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          Skúsiť znova
        </button>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SentryErrorBoundary fallback={ErrorFallback}>
    <App />
  </SentryErrorBoundary>
);
